'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00247 from "./presto.-Presto$$anon$7.js";
import * as $j_presto$002etypes$0024$002dCompact$002dGroup$0024 from "./presto.types$-Compact-Group$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$6() {
  this.bb6 = null;
  this.baY = null;
  this.baZ = false;
  this.bb7 = null;
  this.bb8 = false;
  this.bbb = null;
  this.bb4 = null;
  this.bb5 = false;
  this.bb0 = null;
  this.bb1 = false;
  this.bb2 = null;
  this.bb3 = false;
  this.bb9 = false;
  this.bba = false;
  this.bb6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bbb = "CompactGroup";
}
export { $c_Lpresto_Presto$$anon$6 as $c_Lpresto_Presto$$anon$6 };
$p = $c_Lpresto_Presto$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$6;
/** @constructor */
function $h_Lpresto_Presto$$anon$6() {
}
export { $h_Lpresto_Presto$$anon$6 as $h_Lpresto_Presto$$anon$6 };
$h_Lpresto_Presto$$anon$6.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bb6;
});
$p.M = (function() {
  if ((!this.baZ)) {
    this.baY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.baZ = true;
  }
  return this.baY;
});
$p.O = (function() {
  if ((!this.bb8)) {
    this.bb7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bb8 = true;
  }
  return this.bb7;
});
$p.E = (function() {
  return this.bbb;
});
$p.t = (function() {
  if ((!this.bb5)) {
    this.bb4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bb5 = true;
  }
  return this.bb4;
});
$p.N = (function() {
  if ((!this.bb1)) {
    this.bb0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iK(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kw())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bb1 = true;
  }
  return this.bb0;
});
$p.Q = (function() {
  if ((!this.bb3)) {
    this.bb2 = new $j_presto$002e$002dPresto$0024$0024anon$00247.$c_Lpresto_Presto$$anon$7();
    this.bb3 = true;
  }
  return this.bb2;
});
$p.v = (function() {
  if ((!this.bba)) {
    this.bb9 = false;
    this.bba = true;
  }
  return this.bb9;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee50) => ((p) => \u03b4scrutinee50.acU(p)))($j_presto$002etypes$0024$002dCompact$002dGroup$0024.$m_Lpresto_types$CompactGroup$())));
});
var $d_Lpresto_Presto$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$6, "presto.Presto$$anon$6", ({
  Nq: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$6 as $d_Lpresto_Presto$$anon$6 };
//# sourceMappingURL=presto.-Presto$$anon$6.js.map
